import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    pageShell: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        padding: `${theme.spacing(2)} ${theme.spacing(4)} ${theme.spacing(6)}`,
        [theme.down('desktop')]: {
            padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(4)}`,
        },
    },

    legacySection: {
        border: `1px solid ${theme.colors.grey_light}`,
        borderRadius: theme.radius,
        background: theme.colors.white,
        overflow: 'hidden',
        boxShadow: '0 18px 40px rgba(39, 31, 77, 0.06)',
    },

    legacyHeader: {
        ...flex('row', 'space-between', 'center'),
        gap: theme.spacing(2),
        padding: theme.spacing(4),
        background: theme.isDark
            ? `linear-gradient(135deg, ${theme.colors.surface_elevated} 0%, ${theme.colors.grey_light} 100%)`
            : `linear-gradient(135deg, ${theme.colors.white} 0%, rgba(233, 230, 239, 0.7) 100%)`,
        [theme.down('desktop')]: {
            alignItems: 'flex-start',
            flexDirection: 'column',
        },
    },

    legacyHeaderText: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        minWidth: 0,
    },

    legacyEyebrow: {
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: theme.colors.violet_primary,
    },

    legacyTitle: {
        fontSize: 24,
        lineHeight: 1.2,
        fontWeight: 700,
        color: theme.colors.black,
        fontFamily: theme.font.primary,
    },

    legacyDescription: {
        fontSize: 14,
        lineHeight: 1.5,
        color: theme.colors.grey_text,
        maxWidth: 680,
    },

    legacyToggle: {
        minWidth: 190,
    },

    legacyContent: {
        padding: `${theme.spacing(1)} ${theme.spacing(0)} ${theme.spacing(3)}`,
    },

    goToUser: {
        color: theme.colors.violet_primary,
        fontSize: 24,

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
    },

    gridActions: {
        ...flex('row', 'space-between', 'center'),
        padding: `${0}px ${theme.spacing(4)}`,
        marginBottom: theme.spacing(4),
        [theme.down('desktop')]: {
            padding: `${0}px ${theme.spacing(2)}`,
            gap: theme.spacing(2),
            alignItems: 'flex-start',
            flexDirection: 'column',
        },
    },

    filters: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        [theme.down('desktop')]: {
            width: '100%',
            flexWrap: 'wrap',
        },
    },

    pageTitle: {
        display: 'flex',
        alignItems: 'center',
    },

    loader: {
        color: theme.colors.violet_primary,
        marginLeft: theme.spacing(4),
    },

    searchWrapper: {
        width: '100%',
        maxWidth: 312,
        [theme.down('mobile')]: {
            maxWidth: 'none',
        },
        [theme.down('desktop')]: {
            width: '100%',
        },
    },

    gridItemWrapper: {
        width: `calc(33.333% - ${theme.spacing(4)})`,
        border: `1.5px solid ${theme.colors.grey_light}`,
        background: theme.colors.white,
        margin: `${0}px ${theme.spacing(2)} ${theme.spacing(4)}`,
        marginBottom: theme.spacing(4),
        borderRadius: theme.radius,
    },

    heading: {
        padding: theme.spacing(6),
        ...flex('row', 'space-between', 'center'),
    },

    userInfo: {
        ...flex('row', 'flex-start', 'center'),
    },

    avatar: {
        marginRight: theme.spacing(3),
    },

    userName: {
        fontSize: 16,
        lineHeight: 1.5,
        fontWeight: 600,
        color: theme.colors.black,
    },
}));
